module.exports = __webpack_public_path__ + "img/banner-icon-danger.6de55aa4.svg";